import { useItemLinks } from "@core-ui/stores/ItemLinksStore/ItemLinksStore.provider";
import { Search } from "@ext/serach/components/Search";
import { GlassToolbar } from "@ui-kit/GlassToolbar";
import { SearchButton } from "./SearchButton";

export const SearchToolbar = () => {
	const itemLinks = useItemLinks();

	return (
		<GlassToolbar className="min-w-0 flex-1 px-1">
			<Search
				isHomePage={false}
				itemLinks={itemLinks}
				trigger={<SearchButton className="w-full justify-start h-8" data-testid="catalog-search-trigger" />}
			/>
		</GlassToolbar>
	);
};
